/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Reply_Incomplete_LabelInputs */

const en_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply Incomplete`)
};

const fr_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reponse incomplete`)
};

const de_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort unvollständig`)
};

const it_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposta incompleta`)
};

const ru_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ответ неполный`)
};

const es_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta incompleta`)
};

const zh_cn2_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回复未完成`)
};

const ja_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返信が未完了`)
};

const hi_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तर अधूरा है`)
};

const pt_pt2_style_guide_manager_reply_incomplete_label = /** @type {(inputs: Style_Guide_Manager_Reply_Incomplete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resposta incompleta`)
};

/**
* | output |
* | --- |
* | "Reply Incomplete" |
*
* @param {Style_Guide_Manager_Reply_Incomplete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_reply_incomplete_label = /** @type {((inputs?: Style_Guide_Manager_Reply_Incomplete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Reply_Incomplete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_reply_incomplete_label(inputs)
	if (locale === "de") return de_style_guide_manager_reply_incomplete_label(inputs)
	if (locale === "it") return it_style_guide_manager_reply_incomplete_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_reply_incomplete_label(inputs)
	if (locale === "es") return es_style_guide_manager_reply_incomplete_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_reply_incomplete_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_reply_incomplete_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_reply_incomplete_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_reply_incomplete_label(inputs)
	return en_style_guide_manager_reply_incomplete_label(inputs)
});